import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PageContainer from '../../layout/PageContainer';
import CreditPolicyList from './CreditPolicyList';
import {
  ROLES_ASEGURADO,
  ROLES_CORREDOR,
} from 'CONST';
import { userHasRole } from 'helpers/helpers';


const CreditPolicyListContainer = () => {
  const user = useSelector((state) => state.login.user);
  const creditPolicies = useSelector((state) => state.credito.list.creditPolicies);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const [policyId, setPolicyId] = useState(null);

  // Es asegurado únicamente, no es corredor
  const isAsegurado = userHasRole(user, ROLES_ASEGURADO) && !userHasRole(user, ROLES_CORREDOR);

  const breadcrumbs = React.useMemo(() => {
    if (isAsegurado) {
      return [{ id: 0, name: 'SEGURO DE CR\u00C9DITO', url: '/' }, { id: 1, name: 'MI P\u00D3LIZA' }];
    }

    return [
      { id: 0, name: 'SEGURO DE CR\u00C9DITO', url: '/' },
      { id: 1, name: 'ASEGURADO', url: '/asegurado/polizas-credito' },
      { id: 2, name: 'P\u00D3LIZAS CR\u00C9DITO'},
    ];
  }, [isAsegurado]);

  useEffect(() => {
    if (!isAsegurado || initialLoadComplete || creditPolicies?.data.length === 0) return;

    setInitialLoadComplete(true);

    if (creditPolicies.data.length !== 1) return;

    setPolicyId(creditPolicies.data[0].id);
  }, [creditPolicies, initialLoadComplete]);

  if (policyId) return <Redirect to={`/asegurado/polizas-credito/${policyId}`} />;

  return (
    <PageContainer
      breadcrumbs={breadcrumbs}
      clientFilter={{
        type: 'asegurado',
        ramo: 'credito',
        showFilter: true,
      }}
    >
      {(client) => (
        <CreditPolicyList client={client} />
      )}
    </PageContainer>
  );
}

export default CreditPolicyListContainer;
